import request from "@/utils/request";

export default function agentChangeDeviceModule(params) {
    return request({
        url: `/device/device/agentChangeDeviceModule/`,
        method: 'post',
        params
    })
}
